import { coachApi } from '@shared/api/client';
import type { DomainRecord, RedirectRecord } from './types';
import {
  adaptDomainRecord,
  adaptDomainRecordList,
  adaptRedirectRecord,
  adaptRedirectRecordList,
} from './adapters';

export const domainsApi = {
  listDomains: async (siteId: string): Promise<DomainRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/domains`);
    return adaptDomainRecordList(raw);
  },
  createDomain: async (
    siteId: string,
    data: { hostname: string; is_primary?: boolean }
  ): Promise<DomainRecord> => {
    const raw = await coachApi.post<unknown>(`/webbuilder/sites/${siteId}/domains`, data);
    return adaptDomainRecord(raw);
  },
  verifyDomain: (siteId: string, domainId: string): Promise<{ verified: boolean; message: string }> =>
    coachApi.post<{ verified: boolean; message: string }>(
      `/webbuilder/sites/${siteId}/domains/${domainId}/verify`,
      {}
    ),

  listRedirects: async (siteId: string): Promise<RedirectRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/redirects`);
    return adaptRedirectRecordList(raw);
  },
  createRedirect: async (
    siteId: string,
    data: { source_path: string; target_url: string; status_code: number }
  ): Promise<RedirectRecord> => {
    const raw = await coachApi.post<unknown>(`/webbuilder/sites/${siteId}/redirects`, data);
    return adaptRedirectRecord(raw);
  },
  deleteRedirect: (siteId: string, redirectId: string): Promise<{ deleted: boolean }> =>
    coachApi.delete<{ deleted: boolean }>(`/webbuilder/sites/${siteId}/redirects/${redirectId}`),
};

export const webbuilderApi = domainsApi;
export type * from './types';
